import React from 'react';
import type { AxiosInstance } from 'axios';
import PacksTable from './PacksTable';
import AccountLabelsTable from './AccountLabelsTable';
import AlertRecipientsTable from './AlertRecipientsTable';
import type {
    FortiFlexPack,
    FortiFlexAccountLabel,
    FortiFlexAlertRecipient,
} from '../hooks/useFortiFlexData';

interface ManagementTabProps {
    packs: FortiFlexPack[];
    accountLabels: FortiFlexAccountLabel[];
    alertRecipients: FortiFlexAlertRecipient[];
    api: AxiosInstance;
    onMutatePacks: () => void;
    onMutateLabels: () => void;
    onMutateRecipients: () => void;
}

const ManagementTab: React.FC<ManagementTabProps> = ({
    packs,
    accountLabels,
    alertRecipients,
    api,
    onMutatePacks,
    onMutateLabels,
    onMutateRecipients,
}) => {
    return (
        <div className="space-y-8">
            <PacksTable packs={packs} api={api} onMutate={onMutatePacks} />
            <AccountLabelsTable
                accountLabels={accountLabels}
                api={api}
                onMutate={onMutateLabels}
            />
            <AlertRecipientsTable
                recipients={alertRecipients}
                api={api}
                onMutate={onMutateRecipients}
            />
        </div>
    );
};

export default ManagementTab;
